import React from "react";
import PathConstants from "./path-constants";
import { RequireAppealId } from "../components/shared/require-appeal-id";

// Report Appeal Result Flow
const AppealWonPage = React.lazy(
  () => import("../pages/product/reporting-flow/appeal-won"),
);
const ReviewAndSharePage = React.lazy(
  () => import("../pages/product/reporting-flow/review-and-share"),
);
const DenialUpheldPage = React.lazy(
  () => import("../pages/product/reporting-flow/denial-upheld"),
);
const DenialUpheldClaimFilePage = React.lazy(
  () => import("../pages/product/reporting-flow/denial-upheld-claim-file"),
);
const AppealLostPage = React.lazy(
  () => import("../pages/product/reporting-flow/appeal-lost"),
);

const routes = [
  {
    path: PathConstants.AppealWon,
    element: <AppealWonPage />,
  },
  {
    path: PathConstants.ReviewAndShare,
    element: <ReviewAndSharePage />,
  },
  {
    path: PathConstants.DenialUpheld,
    element: (
      <RequireAppealId>
        <DenialUpheldPage />
      </RequireAppealId>
    ),
  },
  {
    path: PathConstants.DenialUpheldClaimFile,
    element: (
      <RequireAppealId>
        <DenialUpheldClaimFilePage />
      </RequireAppealId>
    ),
  },
  {
    path: PathConstants.AppealLost,
    element: <AppealLostPage />,
  },
];

export default routes;
